const LOCALE = {
    // Additions and services
    TRYING_ON: "Примерка на дому",
    NOTIFY_ORDER_DELIVERY: "Уведомление о создании заказа в СДЭК",
    PART_DELIV: "Частичная доставка",
    COURIER_PACKAGE_A2: "Пакет курьерский А2",
    BUBBLE_WRAP: "Воздушно-пупырчатая плёнка",
    ENVELOPE_A4_CDEK_FREE: "Бумажный конверт",
    GET_UP: "Подъем на этаж",
    LOADING_OPERATIONS_AT_THE_SENDER: "ПРР у отправителя",
    LOAD_THE_OPERATION_AT_THE_RECIPIENT: "ПРР у получателя",
    BOX: "Коробка",
    CARTON_BOX_XS: "Коробка XS",
    CARTON_BOX_S: "Коробка S 2КГ",
    CARTON_BOX_S_2_KILOS: "Коробка S 2КГ",
    CARTON_BOX_M : "Коробка М",
    CARTON_BOX_L_12_KILOS: "Коробка L 12КГ",
    CARTON_BOX_1KG: "Коробка 1КГ",
    CARTON_BOX_2KG: "Коробка 2КГ",
    CARTON_BOX_3KG: "Коробка 3КГ",
    CARTON_BOX_5KG: "Коробка 5КГ",
    CARTON_BOX_10KG : "Коробка 10КГ",
    CARTON_BOX_20KG : "Коробка 20КГ",
    CARTON_BOX_30KG : "Коробка 30КГ",
    CARTON_BOXES: "Коробки",
    GET_UP_FLOOR_BY_HAND: "Подъем на этаж",
    GET_UP_FLOOR_BY_ELEVATOR: "Подъем на этаж",
    CARTON_BOX_XS_INFO: "Коробка XS (17x12x9) 0.5КГ",
    CARTON_BOX_S_2_KILOS_INFO: "Коробка S (23x19x10) 2КГ",
    CARTON_BOX_M_INFO : "Коробка M (33x25x15) 5КГ",
    CARTON_BOX_L_12_KILOS_INFO: "Коробка L (31x25x38) 12КГ",
    CARTON_BOX_1KG_INFO: "Коробка (24x17x10) 1КГ",
    CARTON_BOX_2KG_INFO: "Коробка (34x24x10) 2КГ",
    CARTON_BOX_3KG_INFO: "Коробка (24x24x21) 3КГ",
    CARTON_BOX_5KG_INFO: "Коробка (40x24x21) 5КГ",
    CARTON_BOX_10KG_INFO : "Коробка (40x35x28) 10КГ",
    CARTON_BOX_20KG_INFO : "Коробка (47x40x43) 20КГ",
    CARTON_BOX_30KG_INFO : "Коробка (69x39x42) 30КГ",
    HEAVY_GOOD: "Тяжёлый груз",
    LATHING: 'Обрешётка',

    // Common fields
    address: "Адрес",
    tg_id: "Telegram ID",
    max_id: "Max ID",
    from_location: "Откуда",
    to_location: "Куда",
    total_size: "Размер посылки",
    total_weight: "Вес посылки",
    calculate_weight: "Объемный вес",
    cityFrom: "Город отправления",
    cityTo: "Город назначения",
    deliveryType: "Тип доставки",
    deliveryMode: "Режим доставки",
    deliveryPeriod: "Срок доставки",
    delivery_sum: "Стоимость доставки",
    calculation_parameters: "Параметры расчёта",
    not_specified: "Не указан",

    fio: "ФИО",
    contract_face: "Контактное лицо",
    number: "Номер телефона",
    additional: "Доп. номер",
    pvz: "ПВЗ",

    insurance: "Страховка за ед. товара",
    weight: "Вес товара",
    vat: "Ставка НДС",
    vat_sum: "Сумма НДС",
    price: "Цена",

    // Step 1 - Invoice Main
    main_section: "Основное",
    payment_on_receipt_label: "Взять оплату с получателя",
    yes: "Да",
    no: "Нет",
    no_vat: "Без НДС",
    sender: "Отправитель",
    receiver: "Получатель",
    third_party: "Третье лицо",
    contract_number: "Номер договора",
    select_contract_number: "Выберите номер договора",
    template: "Шаблон",
    template_name: "Название шаблона",
    template_name_exists: "Шаблон с таким названием уже существует",
    no_template: "Без шаблона",
    who_are_you: "Кем вы являетесь",
    city_from: "Город отправления",
    city_to: "Город назначения",
    search_city: "Поиск города",
    popular_cities: "Популярные города",

    // Step 2 - Tariff Panel
    tariff_selection: "Выбор тарифа",
    sort_by: "Сортировать по",
    period: "Срок",
    filter: "Фильтр",
    no_tariffs_available: "Нет доступных тарифов",
    working_days: "раб. дней",
    from: "от",
    to: "до",
    tariff_not_selected: "Тариф не выбран",
    error: "Ошибка",
    error_loading_tariffs: "Ошибка при загрузке тарифов",

    // Step 3 - Additions
    additional_services_cost: "Стоимость доп. услуг",
    floor: "Этаж",
    has_elevator: "Есть лифт",
    free: "Бесплатно",
    manager_will_inform_price: "Менеджер сообщит цену",
    total: "Итог",

    // Step 4 - Delivery
    phones: "Телефоны",
    field_required: "Поле обязательно",
    name_cannot_be_only_digits: "Название не может состоять только из цифр",
    pvz_selection_factors: "На выбор ПВЗ могут повлиять следующие параметры:",
    goods_weight: "Вес товара",
    volumetric_weight_used: "(используется объемный вес)",
    receiving_city: "Город получения",
    not_selected: "не выбран",
    payment_on_receipt_yes: "Оплата при получении: да",
    trying_on_needed_yes: "Необходимость примерки: да",
    no_suitable_pvz: "Нет подходящих ПВЗ",
    nothing_found: "Ничего не найдено",
    contact_person_required: "Контактное лицо*",
    pickup_address_required: "Адрес забора посылки*",
    pvz_delivery_address_required: "Адрес ПВЗ доставки*",
    delivery_address_required: "Адрес доставки*",
    pickup_date_required: "Дата забора посылки*",
    arrive_from_required: "Приехать с*",
    arrive_to_required: "Приехать до*",
    break_from: "Перерыв с",
    break_to: "Перерыв до",
    phone_number_required: "Номер телефона*",
    additional_number: "Доп. номер",

    // Step 5 - Calculation
    payment_from_receiver: "К оплате с получателя",
    payment_from_receiver_hint: "Рассчитывается только если есть оплата при получении",
    payment_by_contract: "Оплата по договору",
    payment_by_contract_hint: "Оплата, которая взимается по договору",
    additional_collection_from_receiver: "Доп. сбор с получателя",
    additional_collection_hint: "Рассчитывается только если есть оплата при получении.",
    insurance_per_unit: "Страховка за ед. товара",
    additional_charge_cod: "Доп. сбор с получателя (наложенный платеж)",

    // Step 6 - Result Panel
    calculation_params: "Параметры рассчёта",
    additional_services: "Дополнительные услуги",
    sender_info: "Отправитель",
    receiver_info: "Получатель",
    need_barcode: "Нужен штрихкод",
    total_from_client: "Итого с клиента",
    total_by_contract: "Итого по договору",
    no_additional_services: "Нет дополнительных услуг",
    no_information: "Нет информации",
    door: "Дверь",
    warehouse: "Склад",
    floor_word: "этаж",
    without_elevator: "без лифта",
    with_elevator: "с лифтом",
    place_word: "Место",

    // Places Panel
    default_goods_name: "ТНП",
    personal_items: "Личные вещи",
    place_number: "Место #",
    calculated_weight_kg: "Рассчитанный вес, (кг):",
    height_cm: "Высота, см",
    length_cm: "Длина, см",
    width_cm: "Ширина, см",
    weight_kg: "Вес, кг",
    attachment_description: "Описание вложения",
    insurance_per_item: "Страховка за ед. товара",
    quantity: "Кол-во",
    delete_place: "Удалить место",
    goods: "Товары",
    no_name: "Без названия",
    pcs: "шт",
    article: "Артикул",
    goods_name: "Название товара",
    payment_per_item: "Оплата за ед. товара",
    vat_sum_label: "Сумма НДС",
    delete_goods: "Удалить товар",
    add_place: "Добавить место",

    // Steps Header
    new_invoice: "Новая накладная",
    step_main_data: "Основные данные",
    step_tariffs: "Тарифы",
    step_additional_services: "Доп. услуги",
    step_receiver_sender: "Получатель/отправитель",
    step_calculation: "Расчет",
    step_total: "Итого",

    // City Selection
    city_from_placeholder: "Откуда",
    city_to_placeholder: "Куда",

    // Validation Messages
    not_all_required_fields_filled: "Заполнены не все обязательные поля",
    insurance_sum_limit: "Сумма страховки не может превышать 399999р",

    // Common
    loading: "Загрузка",
    save: "Сохранить",
    cancel: "Отмена",
    create: "Создать",
    update: "Обновить",
    delete: "Удалить",
    edit: "Редактировать",
    back: "Назад",
    next: "Далее",
    close: "Закрыть",
    select: "Выбрать",
    search: "Поиск",
    apply: "Применить",
    reset: "Сбросить",

    // Auth
    authorization: "Авторизация",
    identifier: "Идентификатор",
    password: "Пароль",
    contract_number_label: "Номер договора",
    select_language: "Выберите язык",
    language: "Язык",
    russian: "Русский",
    english: "Английский",
    kazakh: "Қазақша",
    agree_terms: "Я согласен с условиями использования",
    login: "Войти",
    how_to_auth: "Как авторизоваться в ассистенте?",
    contact_information: "Контактная информация",
    first_name: "Имя",
    last_name: "Фамилия",
    middle_name: "Отчество (при наличии)",
    phone: "Телефон",
    not_all_fields_filled: "Заполнены не все обязательные поля",
    contract_not_found: "Данный договор отсутствует",
    contract_different_keys: "Для данного договора используются другие ключи интеграции",
    integration_keys_error: "Ошибка с ключами интеграции",

    // First Time Modal
    creating_invoice: "Создание накладной",
    calculating_cost: "Расчет стоимости",
    creating_template: "Создание шаблона",
    editing_template: "Редактирование шаблона",
    creating_claim: "Создание претензии",
    tracking_cargo: "Отслеживание груза",
    auth_login: "Авторизация",
    auth_contact: "Авторизация",
    instruction: "Инструкция",
    watch_short_instruction: "Посмотрите короткую инструкцию по использованию",
    video_instruction: "Видео инструкция",
    not_opening_fullscreen: "Не открывается на полный экран?",
    open_in_new_tab: "Открыть в отдельной вкладке",
    browser_not_support_video: "Ваш браузер не поддерживает видео.",
    understood: "Понятно",
    skip: "Пропустить",
    dont_show_again: "Больше не показывать",

    // Delivery Types
    from_door: "от двери",
    to_door: "до двери",
    from_warehouse: "от склада",
    to_warehouse: "до склада",

    // Calculation Panel
    calculation: "Расчет",
    commission_from_receiver: "Комиссия с получателя",
    delivery_from_receiver: "Доставка с получателя",
    
    // Units
    pcs_short: "шт",
    kg_short: "кг",
    art_short: "арт",
    without_vat: "Без НДС",

    // Templates list
    templates_list_title: "Список шаблонов",
    templates_loading: "Загрузка...",
    templates_error: "Не удалось загрузить шаблоны",
    templates_empty: "Нет сохранённых шаблонов",
    notifications_title: "Уведомления",
    notifications_empty: "Нет уведомлений",
    notifications_load_more: "Загрузить ещё",
    notifications_loading: "Загрузка...",
    notifications_files: "Файлы",
    notifications_file_download: "Скачать",
    templates_create: "Создать шаблон",
    templates_edit: "Редактировать",
    templates_delete: "Удалить",
    templates_delete_confirm: "Удалить шаблон?",
    templates_delete_confirm_title: "Подтверждение удаления",
    templates_delete_warning: "Действие необратимо. Шаблон будет удалён без возможности восстановления.",
    templates_delete_confirm_btn: "Удалить",
    templates_delete_error: "Не удалось удалить шаблон",
    templates_delete_success: "Шаблон успешно удалён",
    templates_contract_number: "Номер договора",
    templates_created_at: "Дата создания",
    templates_template_name: "Название шаблона",
    templates_template_no_name: "Шаблон №",
    templates_role: "Ваша роль",
    who_pay_sender: "Отправитель",
    who_pay_reciver: "Получатель",
    who_pay_another: "Третье лицо",
    templates_from_address: "Адрес отправления",
    templates_to_address: "Адрес получения",

    contracts_list_title: "Список договоров",
    contracts_loading: "Загрузка...",
    contracts_error: "Не удалось загрузить договоры",
    contracts_empty: "Договоры не найдены",
    contracts_create: "Создать договор",
    contracts_delete: "Удалить",
    contracts_delete_confirm: "Удалить договор?",
    contracts_contract_number: "Номер договора",
    contracts_created_at: "Дата создания",
    contracts_client_company_name: "Название компании",
    contracts_disable: "Отключить",
    contracts_disable_confirm_title: "Подтверждение отключения",
    contracts_disable_warning: "Договор {{contract_number}} будет отключён. Действие необратимо.",
    contracts_disable_confirm_btn: "Отключить",
    contracts_disable_success: "Договор успешно отключён",
    contracts_disable_error: "Не удалось отключить договор",

    // Employees
    employees_list_title: "Сотрудники",
    employees_empty: "Сотрудники не найдены",
    employees_contracts_error: "Не удалось загрузить договоры",
    employees_load_error: "Не удалось загрузить сотрудников",
    employees_delete: "Удалить сотрудника",
    employees_delete_confirm_title: "Удаление сотрудника",
    employees_delete_confirm_body: "Удалить сотрудника {{name}}? Действие необратимо.",
    employees_delete_confirm_btn: "Удалить",
    employees_delete_success: "Сотрудник успешно удалён",
    employees_delete_error: "Не удалось удалить сотрудника",
    employees_delete_no_tg_id: "Нет идентификатора сотрудника",
    employees_invite_button: "Пригласить сотрудника",
    employees_invite_title: "Приглашение сотрудника",
    employees_invite_get_link: "Получить ссылку",
    employees_invite_copy_link: "Скопировать ссылку",
    employees_invite_link_copied: "Ссылка скопирована",
    employees_invite_error: "Не удалось получить ссылку",

    // Home & Navigation
    home_title: "Главная",
    nav_home: "Главная",
    nav_menu_title: "Меню",
    nav_menu_open: "Открыть меню",
    nav_menu_close: "Закрыть меню",
    nav_invoice: "Создание накладной",
    nav_templates: "Шаблоны",
    nav_create_template: "Создать шаблон",
    nav_contracts: "Договоры",
    nav_add_contract: "Добавить договор",
    nav_employees: "Сотрудники",
    nav_calculation: "Расчёт доставки",
    nav_claim: "Претензия",
    nav_tracking: "Отслеживание",
    nav_tracking_by_number: "Отслеживание по номеру",
    nav_tracking_from_bot: "Отслеживание из бота",
    nav_feedback: "Обратная связь",
    nav_chat: "Чат",
    nav_instructions: "Инструкции",
    install_app_button: "Установить приложение",
    install_page_title: "СДЭК Ассистент",
    install_page_subtitle: "Добавьте приложение на рабочий стол для быстрого доступа",
    install_page_feature_1: "Быстрое создание накладных",
    install_page_feature_2: "Отслеживание посылок",
    install_page_feature_3: "Push-уведомления о статусах",
    install_page_feature_4: "Работает без Telegram",
    install_page_button: "Установить на рабочий стол",
    install_page_ios_title: "Установка на iPhone / iPad",
    install_page_ios_steps_title: "В Safari добавьте приложение на экран «Домой»:",
    install_page_ios_two_w1a: "Нажмите на иконку",
    install_page_ios_two_home: "На экран «Домой»",
    install_page_ios_two_w2a: "Нажмите",
    install_page_ios_two_w2b: "«Поделиться»",
    install_page_ios_hint: "Если кнопки «Поделиться» не видно внизу экрана, воспользуйтесь вторым способом.",
    install_page_success: "Приложение установлено!",
    install_page_success_subtitle: "Теперь вы можете открыть его с рабочего стола",
    install_page_go_home: "Перейти на главную",
    nav_profile: "Профиль",
    nav_profile_edit: "Редактировать профиль",
    profile_title: "Профиль",
    profile_name: "Имя",
    profile_username: "Имя пользователя",
    profile_contract: "Номер договора",
    profile_no_contracts: "Нет привязанных договоров",
    profile_error: "Не удалось загрузить профиль",
    profile_edit: "Редактировать",
    profile_update_title: "Редактирование профиля",
    profile_update_success: "Профиль успешно обновлён",
    profile_update_error: "Не удалось обновить профиль",
    instructions_list_title: "Видеоинструкции",
    instructions_video_invoice: "Создание накладной",
    instructions_video_templates: "Шаблоны",
    instructions_video_calculation: "Расчёт стоимости",
    instructions_video_claims: "Претензии",
    instructions_video_tracking: "Отслеживание",
    instructions_video_contracts: "Договоры",
    instructions_video_employees: "Сотрудники",
    instructions_video_chat: "Чат с менеджером",

    // EAEU Warning Modal
    attention: "Внимание!",
    eaeu_warning_text: "К заказу необходимо приложить дополнительные документы и предоставить дополнительные сведения, если вам необходимо упрощенное создание, то вернитесь в создание заказа и не меняйте данные в полях «Артикул», «Название товара» и «Кем вы являетесь»",

    share_button: "Поделиться",
    share_copied: "Скопировано",
    share_failed: "Не удалось скопировать",

    // Calculate Invoice
    calculate_invoice_title: "Расчёт накладной",

    // Tracking
    tracking_parcel_title: "Отслеживание посылки",

    // Claim
    new_claim_title: "Новая претензия",
    claim_word: "Претензия",
    your_email: "Ваш email",
    contact_person_fio: "ФИО контактного лица",
    required_sum_rub: "Требуемая сумма",
    describe_situation: "Опишите ситуацию",
    attach_files: "Прикрепить файлы",
    invoice_number_label: "Номер накладной",
    select_invoice: "Выберите накладную",
    incorrect_email: "Некорректный email",
    attach_photo_video: "Прикрепите фото или видео товара",
    file_exceeds_size: "Файл превышает 200MB",
    invalid_file_type: "Недопустимый тип файла",

    // Chat with Manager
    chat_with_manager_title: "Чат с менеджером",
    select_contract_for_chat: "Выберите договор для входа в чат",
    enter_button: "Войти",
    chat_with_manager: "Чат с менеджером",

    // Package Tracking
    track_number_input: "Трек номер",
    enter_track_number: "Введите трек-номер",
    invalid_contract: "Неверный договор",
    invalid_track_number: "Неверный трек-номер",
    find_button: "Найти",
    package_not_found: "Посылка по данному номеру не найдена",
    employee_word: "Сотрудник",

    // Track Item
    track_number_prefix: "Трек №",
    contract_word: "Договор",
    sending_progress: "Отправка...",
    barcode_button: "Штрих-код",
    current_location: "Текущ. местоположение",
    planned_delivery_date: "План. дата доставки",

    // EAEU Manager Modal
    additional_information_title: "Дополнительная информация",
    eaeu_manager_modal_text: "Если вам необходимо приложить к накладной документы для таможенного контроля и СНТ, а также в накладной проставить: грузоотправителя, адрес грузоотправителя, истинного продавца, адрес истинного продавца, Добавить номер акта приема-передачи или ТТН, указать наименование товара на английском языке, код маркировки или честный знак, материал, страну производства или ссылку на товар, обратитесь к менеджеру",

    // Instructions
    instruction_not_found: "Инструкция не найдена",
    specify_video_url: "Пожалуйста, укажите URL видео в параметре key.",
    invalid_url: "Неверный URL",
    key_must_contain_url: "Параметр key должен содержать действительный URL видео.",
    browser_not_support_video_tag: "Ваш браузер не поддерживает тег видео.",

    // First Time Modal Descriptions
    desc_create_invoice: "Узнайте, как быстро создать накладную для отправки груза",
    desc_calculate_cost: "Научитесь рассчитывать стоимость доставки вашего груза",
    desc_create_template: "Создайте шаблон для быстрого создания накладных",
    desc_edit_template: "Узнайте, как изменить существующий шаблон",
    desc_create_claim: "Научитесь создавать претензии по доставке",
    desc_tracking: "Узнайте, как отслеживать статус вашего груза",
    desc_auth: "Узнайте, как авторизоваться в ассистенте",
    desc_auth_contact: "Завершение процесса авторизации",

    // Step 4 - Delivery Panel
    fio_required: "ФИО*",
    fio_or_company_required: "ФИО или название компании*",
    delivery_word: "Доставка",

    // Tracking Options
    select_tracking_option: "Выберите вариант отслеживания",
    by_package_number: "По номеру посылки",
    invoice_created: "Накладная создана",
    invoice_created_in_assistant: "Накладная, созданная в ассистенте",

    // Bot Rating
    assistant_rating_title: "Оценка ассистента",
    rating_label: "Рейтинг",
    select_rating: "Выберите оценку",
    comment_placeholder: "Комментарий",
    fill_required_field: "Заполните обязательное поле",
    submit_rating: "Отправить оценку",
    thanks_for_review: "Спасибо за отзыв!",
    ok_button: "Хорошо",

    // Auth Contact
    contact_phone: "Контактный телефон",
    need_help: "Нужна помощь?",
    video_instruction_link: "Видеоинструкция",
    accept_button: "Принять",
    fill_all_required_fields: "Пожалуйста, заполните все обязательные поля.",
    data_sent_successfully: "Данные успешно отправлены!",

    // City Search
    select_contract_for_city_search: "Для поиска города выберите договор",

    // Voice Input
    voice_panel_title: "Заполнение полей голосом",
    voice_from_to: "Откуда и куда",
    voice_place_and_goods_params: "Параметры места и товара",
    voice_tariffs: "Тарифы",
    voice_additional_services: "Доп. услуги",
    voice_receiver: "Получатель",
    voice_sender: "Отправитель",
    voice_cargo_weight: "Вес груза",
    voice_invoice_number: "Номер накладной",
    voice_problem_description: "Описание проблемы",
    voice_damage_amount: "Сумма ущерба",
    voice_contact_details: "Контактные данные",
    voice_additional_info: "Дополнительная информация",
    voice_analyzing: "Анализируем данные...",
    voice_record_hold: "Нажмите и удерживайте кнопку для записи",
    voice_record_release: "Отпустите кнопку чтобы начать обработку",
    voice_allow_access: "Разрешить доступ",
    
    // Navigation
    go_to_menu: "В главное меню",
}

export default LOCALE